import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { TranslateModule } from '@ngx-translate/core';

import { VC_CommunicationMessage } from '../../../models/view-content.models/view-content.model';

@Component({
  selector: 'app-orga-tabs-tasks',
  templateUrl: './orga-tabs-tasks.component.html',
  styleUrls: ['./orga-tabs-tasks.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    TranslateModule,
  ],
})
export class OrgaTabsTasksComponent {
  @ViewChild(MatSort) sort: MatSort | null = null;

  @Input() tasks: VC_CommunicationMessage[] = [];

  @Output() clickOnTask = new EventEmitter<VC_CommunicationMessage>();

  public displayedColumns: string[] = [
    'task_name',
    'details',
    'goalDateOn',
    'priority',
    'contractor',
    'done',
  ];

  public constructor() {}

  public onRowClicked(row: VC_CommunicationMessage): void {
    this.clickOnTask.emit(row);
  }
}
